import React from "react";

const RecommenderBoxLabel = ({ title, required = false }) => {
  return (
    <div className="font-bold pl-2 text-black">
      {title} {required && <span className="text-red-600">*</span>}
    </div>
  );
};

export default RecommenderBoxLabel;
